import { TiStarFullOutline } from 'react-icons/ti';
import styles from '../store.module.scss';

type TStarAvgProps = {
  reviewAvg: number;
  reviewCount?: number;
  direction?: 'horizontal' | 'column';
  logoMargin?: string;
};

export default function StarAvg({
  reviewAvg,
  reviewCount,
  direction = 'horizontal',
  logoMargin = '6px',
}: TStarAvgProps) {
  return (
    <div
      className={`flex ${
        direction === 'column' ? 'flex-col items-center' : ''
      }`}
    >
      <div className={`text-yellow-400 flex items-center mr-[${logoMargin}]`}>
        <TiStarFullOutline />
      </div>
      <div className="whitespace-nowrap">
        <span
          className={`text-navy-800 font-bold inline-flex items-center h-full`}
        >
          {reviewAvg || 0.0}
        </span>{' '}
        {reviewCount && reviewCount > 0 && (
          <span className="text-zinc-500">
            ({reviewCount > 100 ? '+100' : reviewCount})
          </span>
        )}
      </div>
    </div>
  );
}
